module.exports = __webpack_public_path__ + "img/anjing.96937cdc.svg";